import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { UserNotificationType } from 'src/app/core/types';
import { UserApiService } from 'src/app/core/services/user-api.service';
import { MODAL_DATA } from 'src/app/modal/modal.service';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

export interface PriceListUpdatePopupData {
  notificationId: number;
  notificationType: UserNotificationType;
}

@Component({
  selector: 'gl-price-list-update-popup',
  templateUrl: './price-list-update-popup.component.html',
  styleUrls: ['./price-list-update-popup.component.scss'],
  standalone: false,
})
export class PriceListUpdatePopupComponent implements OnInit, OnDestroy {
  public readonly bodyTranslationKey: string;
  public readonly priceListUrl: string;
  private backdropSub?: Subscription;
  private closing = false;

  constructor(
    private modalRef: ModalOverlayRef,
    private userApiService: UserApiService,
    private translate: TranslateService,
    @Inject(MODAL_DATA) private data: PriceListUpdatePopupData,
  ) {
    this.bodyTranslationKey =
      data.notificationType === 'price_list_update_subscription'
        ? 'price_list_update_subscription_main'
        : 'price_list_update_general_main';
    const lang = (
      this.translate.currentLang ||
      this.translate.defaultLang ||
      ''
    ).toLowerCase();
    this.priceListUrl = lang.startsWith('pl')
      ? 'https://www.goodloading.com/pl/cennik/'
      : 'https://www.goodloading.com/en/price-list/';
  }

  public ngOnInit(): void {
    this.backdropSub = this.modalRef.subscribeBackdrop(() => this.dismiss());
  }

  public ngOnDestroy(): void {
    this.backdropSub?.unsubscribe();
  }

  public dismiss(): void {
    if (this.closing) {
      return;
    }
    this.closing = true;
    this.userApiService.updateUserNotification(this.data.notificationId).subscribe({
      next: () => this.modalRef.close(),
      error: () => {
        this.closing = false;
      },
    });
  }
}
